import React, {
    Fragment,
    useState
} from 'react';

import {BaseTableColumn} from "../../Common/Tables/BaseTableColumn";
import {ConfirmationDialog} from "../../Common/ConfirmationDialog";
import {GenericModelViewer} from "../../Common/GenericModelViewer";
import {Permit} from "../../../Models/StreamBank/Permit";
import {service as PermitService} from "../../../Services/PermitService";
import {PermitModal} from "../../Modals/PermitModal";
import {useFetchServiceModel} from "../../../Hooks/ServiceHooks";

export const PermitNameTableColumn = (props) => {
    const [permitId, setPermitId] = useState(null);
    const permit = useFetchServiceModel(PermitService, permitId);
    
    return (
        <Fragment>
            <PermitModal
                permit={permit}
                editable={false}
                show={!!permitId && !!permit}
                onHide={() => setPermitId(null)}
            />
            <a className="sb-actionable-link" onClick={() => setPermitId(props.rowData.permitId)}>
                {props.Value}
            </a>
        </Fragment>
    );
}